import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { BasicModal } from "./basic-modal";
import { useAppDispatch } from "../../app/hooks";
import { logOut } from "../game-state/games.functions";

export const MenuModal = ({ dismiss }: { dismiss: () => void }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleToOverview = useCallback(() => {
    navigate("/");
    dismiss();
  }, [navigate, dismiss]);

  return (
    <BasicModal>
      <>
        <div className="flex justify-center">
          <h1 className="font-sans text-2xl font-extrabold mb-4 text-blue-600">
            Menu
          </h1>
        </div>
        <button onClick={handleToOverview} className="btn-primary mb-4">
          <i className="fa fa-sign-in-alt mr-2 fa-2x" />
          <span>Terug naar overzicht</span>
        </button>
        <button onClick={dismiss} className="btn-secondary mb-4">
          <i className="fa fa-paw mr-2 fa-2x" />
          <span>Menu Sluiten</span>
        </button>
        <button
          onClick={() => dispatch(logOut())}
          className="btn-primary bg-red-500 hover:bg-red-600"
        >
          <i className="fa fa-power-off mr-2 fa-2x" />
          <span>Uitloggen</span>
        </button>
      </>
    </BasicModal>
  );
};
